"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableFooterTotalsRow = void 0;
const debug_1 = __importDefault(require("debug"));
const vue_1 = __importDefault(require("vue"));
const constants = __importStar(require("./constants"));
const vue_property_decorator_1 = require("vue-property-decorator");
const cell_1 = require("./cell");
const row_header_1 = require("./row-header");
const footer_totals_row_model_1 = require("./model/footer-totals-row-model");
const log = (0, debug_1.default)('itp:ui:components:datatable:row');
let ItpDataTableFooterTotalsRow = class ItpDataTableFooterTotalsRow extends vue_1.default {
    model;
    row;
    columns;
    render(h) {
        return h('tr', {
            class: {
                'itp-datatable__footer-totals': true,
                'footer-totals': true,
                datarow: true
            }
        }, this.renderCells(h));
    }
    renderCells(h) {
        const result = [];
        for (let col of this.columns) {
            if (!this.row.displayTotalsForColumn(col)) {
                result.push(this.renderEmptyCell(h, col));
                continue;
            }
            result.push(this.renderCell(h, col));
        }
        return result;
    }
    renderSystemColumnCell(h, col) {
        const name = col.name;
        switch (name) {
            case constants.COLNAME_ROW_HEADER:
                return this.renderRowHeader(h, col);
            default:
                return h('td', {
                    attrs: {
                        dataColumn: name
                    }
                });
        }
    }
    renderCell(h, col) {
        return h('td', {
            class: this.getCellClassName(col)
        }, [
            h(col.cellFormatter.component, {
                attrs: {
                    dataColumn: col.name
                },
                props: {
                    col: col,
                    row: this.row,
                    value: this.row.getValue(col.field),
                    globs: this.model.options.globs,
                    messages: this.model.messages,
                    lang: this.model.lang
                },
                scopedSlots: col.scopedSlots
            })
        ]);
    }
    renderEmptyCell(h, col) {
        return h('td', {
            class: this.getCellClassName(col),
            attrs: {
                dataColumn: col.name
            },
            props: {}
        });
    }
    renderRowHeader(h, col) {
        return h('ItpDataTableRowRowHeader', {
            props: {
                col,
                row: this.row,
                lang: this.model.lang
            }
        });
    }
    getCellClassName(col) {
        return [
            'itp-datatable__table-cell',
            'position-relative',
            col.getCellClass(false, this.row)
        ];
    }
};
exports.ItpDataTableFooterTotalsRow = ItpDataTableFooterTotalsRow;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", footer_totals_row_model_1.FooterTotalsRowModel)
], ItpDataTableFooterTotalsRow.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], ItpDataTableFooterTotalsRow.prototype, "columns", void 0);
exports.ItpDataTableFooterTotalsRow = ItpDataTableFooterTotalsRow = __decorate([
    (0, vue_property_decorator_1.Component)({
        components: {
            ItpDataTableCell: cell_1.ItpDataTableCell,
            ItpDataTableRowRowHeader: row_header_1.ItpDataTableRowRowHeader
        },
        inject: {
            model: 'model'
        }
    })
], ItpDataTableFooterTotalsRow);
//# sourceMappingURL=footer-totals-row.js.map